// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetHouseOfferHistoryByHouseIdRequest,
  TGetHouseOfferHistoryByHouseIdModel,
  IMappers,
  TGetHouseOfferHistoryByHouseIdResponse,
  IGetHouseOfferHistoryByHouseIdResponse,
  IGetHouseOfferHistoryByHouseIdResponseError,
} from './types';

export const defaultConfig: TGetHouseOfferHistoryByHouseIdModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'valuation-offer-history',
  pathApi: '/v1/get-house-offer-history-by-house-id/',
  requestType: 'json',
} as TGetHouseOfferHistoryByHouseIdModel;

export function createGetHouseOfferHistoryByHouseIdModel(
  parameters: IGetHouseOfferHistoryByHouseIdRequest,
): TGetHouseOfferHistoryByHouseIdModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetHouseOfferHistoryByHouseIdOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetHouseOfferHistoryByHouseIdRequest;
}

export async function fetchGetHouseOfferHistoryByHouseId<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseOfferHistoryByHouseIdOptions<TResponse200, TResponse400>): Promise<
  TGetHouseOfferHistoryByHouseIdResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetHouseOfferHistoryByHouseIdModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetHouseOfferHistoryByHouseIdResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetHouseOfferHistoryByHouseIdResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetHouseOfferHistoryByHouseIdResponse;
}
